import React from "react";
import Faq from "react-faq-component";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import Seo from "../components/Seo";

import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";

import FullWidthImage from "../components/FullWidthImage";
import DisplayContentHeader from "../components/DisplayContentHeader";

// eslint-disable-next-line
export const FaqPageTemplate = ({
  title,
  subtitle,
  image,
  meta,
  faqs,
  body,
  helmet,
}) => {
  const PageContent = HTMLContent || Content;
  const heroImage = getImage(image) || image;

  const showTitle = meta.showTitle;

  let filteredFaq = [];

  let content = null;
  let links = [];
  let relatedLinks = [];

  faqs.forEach((element) => {
    content = element.answer || "";

    if (element.related) {
      links = [];
      relatedLinks = element.related;

      relatedLinks.forEach((relElement) => {
        if (relElement.link) {
          links.push(
            "<a href='" + relElement.link + "'>" + relElement.title + "</a>"
          );
        } else {
          links.push(relElement.title);
        }
      });
      content = content + "<ul><li>" + links.join("</li><li>") + "</li></ul>";
      filteredFaq.push({
        title: element.question || "",
        content: content + "<br/>",
      });
    } else {
      filteredFaq.push({
        title: element.question || "",
        content: content + "<br/><br/>",
      });
    }
  });

  const data = {
    rows: filteredFaq,
  };
  let contentHeaderTitle,
    linkBack = false;
  if (subtitle !== "Frequently Asked Questions") {
    contentHeaderTitle = `${subtitle}`;
    linkBack = true;
  } else {
    contentHeaderTitle = `FAQ`;
  }

  return (
    <div>
      {helmet || null}
      {showTitle ? (
        <FullWidthImage
          img={heroImage}
          title={title}
          subheading={subtitle}
          imgPosition="center"
        />
      ) : (
        <FullWidthImage img={heroImage} imgPosition="center" />
      )}

      <section className="section section--gradient">
        <div className="container">
          <div className="content">
            <div className="content">
              {linkBack ? (
                <>
                  <DisplayContentHeader
                    title={contentHeaderTitle}
                    parent="FAQs"
                    parentSlug="/faqs"
                  />
                </>
              ) : (
                <>
                  <DisplayContentHeader title={contentHeaderTitle} />
                </>
              )}
            </div>

            <PageContent className="content" content={body} />

            <div className="content">
              <Faq data={data} />
            </div>
            {linkBack ? (
              <>
                Do you have more general questions? Try our{" "}
                <a href="/faq">Hazard County Shuttle FAQ</a>.
              </>
            ) : null}
          </div>
        </div>
      </section>
    </div>
  );
};

FaqPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.shape({
    showTitle: PropTypes.bool,
  }),
  faqs: PropTypes.array,
  body: PropTypes.string,
  helmet: PropTypes.object,
};

const FaqPage = ({ data }) => {
  const { markdownRemark: post } = data;
  //console.log(post);
  let imageSrc =
    post.frontmatter.image.childImageSharp.gatsbyImageData.images.fallback.src;

  return (
    <Layout>
      <FaqPageTemplate
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
        image={post.frontmatter.image}
        meta={post.frontmatter.meta}
        faqs={post.frontmatter.faqs.faq}
        body={post.html}
        helmet={
          <Seo
            title={post.frontmatter.title}
            summary={post.frontmatter.summary}
            image={imageSrc}
            article={false}
          />
        }
      />
    </Layout>
  );
};

FaqPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default FaqPage;
// 407462ec-6ff0-50bf-bdf8-08be5f90cc60
export const faqPageQuery = graphql`
  query FaqPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        subtitle
        faqs {
          faq {
            question
            answer
            related {
              title
              link
            }
          }
        }
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        meta {
          showTitle
        }
        summary
      }
    }
  }
`;
